import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { DocumentService } from "../../../../services/document/document.service";
import { documentStatus } from "../../../../constants";
import { useMemo } from "react";
import { useUser } from "../../../../hook";
import { IFileDocumentInfo } from "../../../../models/IFileDocumentInfo";
import { useSearchParams } from "../../../../hook/use-search-params";
import { getEnv } from "../../../../AppConfigs";

const initValue: IFileDocumentInfo = {
  id: 0,
  docStatusId: documentStatus.new.id,
  docStatusValue: documentStatus.new.value,
  docStatus: documentStatus.new.label,
  IsCustomEditor: true,
};

export const useDocumentInfo = () => {
  const { id } = useParams<{ id: string }>();
  const { email } = useUser();
  const { searchParams } = useSearchParams();
  const isPublishStatus = searchParams.get("status") === documentStatus.publish.value;
  const listId = !isPublishStatus ? "" : getEnv("REACT_APP_WORKING_DOCS_PUBLISH_INF_LIST_ID");

  const { data, isLoading } = useQuery({
    queryKey: ["document-info", id, listId],
    queryFn: () =>
      !isPublishStatus
        ? DocumentService.getDocumentInfo(id, listId)
        : DocumentService.getPublicDocumentInfoFromWorkingDocument(id),
  });

  const mappedData = useMemo(() => {
    if (!data) return initValue;
    return data;
  }, [data]);

  const docReader = useMemo(() => {
    if (!data) return [];
    return !data.docReaders ? [] : [...data.docReaders];
  }, [data]);

  const isRead = useMemo(
    () => docReader && docReader?.findIndex((e: any) => e.email.toLowerCase() === email.toLowerCase()) !== -1,
    [docReader, email],
  );

  const fileAssignedTo = useMemo(() => {
    if (!data) return [];
    return !data.fileAssignedTo ? [] : JSON.parse(data.fileAssignedTo);
  }, [data]);

  return { data, mappedData, isLoading, docReader, isRead, fileAssignedTo };
};
